import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import {Pagination, Autoplay } from 'swiper/modules';
import './OurJourney.css';

import about from '../assets/2026-27 Exec.jpg';
import gallery2020 from '../assets/home/2020-21 Tutee Orientation.png';
import gallery2021 from '../assets/home/2021 EPSB Division Recognition.jpeg';
import gallery2022 from '../assets/home/2021-22 Tutor Orientation.png';
import gallery2023 from '../assets/2022-23 Exec.jpg';
import gallery2024 from '../assets/Website V1.png';
import gallery2025 from '../assets/home/2024-25 Curious Colors.jpg';
import gallery2026 from '../assets/home/2025-26 Audreys Sponsorship.png';

export default function OurJourney() {
  const [counts, setCounts] = useState({ schools: 0, tutors: 0, students: 0 });

  // Incrementing counters
  useEffect(() => {
    const target = { schools: 41, tutors: 689, students: 908 };
    const duration = 2000;
    const startTime = performance.now();

    const animate = (time) => {
      const progress = Math.min((time - startTime) / duration, 1);
      setCounts({
        schools: Math.floor(progress * target.schools),
        tutors: Math.floor(progress * target.tutors),
        students: Math.floor(progress * target.students),
      });
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, []);

  const galleryImages = [
    { src: gallery2020, title: '2020', caption: 'The Life Long Learners program officially began.', link: '' },
    { src: gallery2021, title: '2021', caption: 'Life Long Learners was nominated and recognized by EPSB for their dedication to this mission.', link: 'https://www.epsb.ca/media/epsb/ourdistrict/divisionrecognition/2020-21-division-recognition.pdf#page=31' },
    { src: gallery2022, title: '2022', caption: 'Life Long Learners\' team of tutors grew to over 50 tutors.', link: '' },
    { src: gallery2023, title: '2023', caption: 'Life Long Learners expanded its executive team to two portfolios, growing from three to nine executives.', link: '' },
    { src: gallery2024, title: '2024', caption: 'Life Long Learners rebranded and published the first version of its official website.', link: '' },
    { src: gallery2025, title: '2025', caption: 'Life Long Learners revamped its events, holding its first in-person event and two online events.', link: '' },
    { src: gallery2026, title: '2026', caption: 'Life Long Learners received its first in-kind sponsorship from Audreys Books Ltd., a local bookstore in Edmonton, AB.', link: 'https://www.audreys.ca/' },
  ];

  return (
    <div className="our-journey-container">

      {/* Who We Are Section */}
        <motion.section
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="mission-section"
        >
        <img src={about} alt="Mission" className="mission-image" />
        <div className="mission-text">
            <h1>Who We Are</h1>
            <p>
            Life Long Learners is an EPSB-recognized tutoring program founded in October 2020 with the intention of providing Kindergarten to Grade 9 students with free and accessible tutoring services remotely. 
            With a passionate team of high school and university tutors, we aim to empower students to achieve their full academic potential while fostering a love for learning.
            </p>
        </div>
        </motion.section>


      {/* Counters Section */}
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
        style={{ display: 'flex', justifyContent: 'space-around', padding: '3rem 2rem', backgroundColor: '#9FD6DC', borderRadius: '12px', margin: '2rem auto', maxWidth: '1000px' }}
      >
        <div style={{ textAlign: 'center' }}>
          <h2>{counts.schools}+</h2>
          <p>Schools Served</p>
        </div>
        <div style={{ textAlign: 'center' }}>
          <h2>{counts.tutors}+</h2>
          <p>Volunteer Tutors</p>
        </div>
        <div style={{ textAlign: 'center' }}>
          <h2>{counts.students}+</h2>
          <p>Students Tutored</p>
        </div>
      </motion.section>

      {/* Image Carousel Section */}
      <motion.section
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.8 }}
        className="carousel-section"
      >
        <h2>Snapshots of Our Journey Over the Years</h2>
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          pagination={{ clickable: true }}
          loop
          autoplay={{ delay: 4000 }}
          modules={[Pagination, Autoplay]}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {galleryImages.map((img, idx) => (
            <SwiperSlide key={idx}>
              <div className="carousel-card">
                <div className="carousel-image-container">
                  <img src={img.src} alt={img.caption} />
                </div>
                <div className="carousel-text">
                  <h4>{img.title}</h4>
                  <p>{img.caption}</p>
                </div>
                {img.link ? (
                  <a href={img.link} target="_blank" rel="noopener noreferrer">
                    <button className="learn-more-btn">Learn More</button>
                  </a>
                ) : (
                  <div className="learn-more-btn-placeholder" />
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.section>

    </div>
  );
}

